import b from 'b_';
import cx from 'classnames';
import { Button, Link, SimpleText, SimpleCallback, Text } from 'platform-components';
import React from 'react';

import { NOTIFICATION_TYPE, NOTIFICATION_THEME } from 'common.components/changes-notification/typings';
// @ts-ignore
import { IconWarningTriangle } from 'common.components/icon2';

interface LinkProps {
    isRouter?: boolean;
    target?: '_blank';
    to: string;
}

interface Props {
    buttonTextId: string;
    linkProps: LinkProps;
    messageTextId: string;
    messageTextValues: Record<string, any>;
    mix?: string;
    onClose: SimpleCallback;
}

const NotificationWithAction = (props: Props) => {
    const { buttonTextId, linkProps, messageTextId, messageTextValues, onClose, mix } = props;

    return (
        <div
            className={cx(
                mix,
                b('changes-notification', {
                    theme: NOTIFICATION_THEME.WARNING,
                    type: NOTIFICATION_TYPE.WITH_ACTION,
                })
            )}
        >
            <div className="changes-notification__message">
                <IconWarningTriangle mix="changes-notification__icon" />
                <Text id={messageTextId} values={messageTextValues} />
            </div>
            <div className="changes-notification__controls">
                <Link {...linkProps}>
                    <Button
                        className="changes-notification__button"
                        onClick={onClose}
                        transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                        view={Button.VIEW.PSEUDO}
                    >
                        <SimpleText id={buttonTextId} />
                    </Button>
                </Link>
            </div>
        </div>
    );
};

export default NotificationWithAction;
